export default {
    card: { height: 1, pt: 0.5 },
    closeIcon: { cursor: "pointer" },
}